import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IGusCompanyDataVm } from '../gus-company-data-vm.model';
@Injectable({ providedIn: 'root' })
export class GusCompanyDataService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/GusCompanyData`;
  }
  get(nip: string): Observable<IGusCompanyDataVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (nip !== undefined && nip !== null) {
      params = params.set('nip', nip.toString());
    }
    return this.http.get<IGusCompanyDataVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
